import { secureApiGet } from '../secureHttp';
import { Psychologist } from '../../../types/psychologist';

export interface PsychologistsListResponse {
  data: Psychologist[];
  total: number;
}

export interface PsychologistsListQuery extends Record<string, unknown> {
  skip?: number;
  take?: number;
  status?: string;
  specialization?: string;
  /**
   * Filtro por ID exacto de psicóloga. El endpoint v2 NO soporta `search`
   * (se ignora y devuelve todas), por eso para traer una psicóloga puntual
   * hay que usar `id`.
   */
  id?: string;
}

interface ApiCoreListResponse<T> {
  metadata?: {
    total?: number;
    pages?: number;
    current_page?: number;
    per_page?: number;
    has_next_page?: boolean;
    has_prev_page?: boolean;
  };
  results: T[];
}

interface ApiCorePsychologistItem {
  id: string;
  currency?: string;
  payment_method?: string;
  ranking_category?: Psychologist['ranking_category'];
  process_limit?: number;
  process_limit_preferred?: number | null;
  status?: { id: string; name?: string };
  user?: { name?: string; surname?: string };
  timezone?: string | null;
}

export async function getPsychologists(params?: PsychologistsListQuery): Promise<PsychologistsListResponse> {
  const resp = await secureApiGet<ApiCoreListResponse<ApiCorePsychologistItem>>('/v2/psychologists', params);
  const items = Array.isArray(resp.results) ? resp.results : [];
  const data: Psychologist[] = items.map((p) => ({
    id: p.id,
    nickname: [p.user?.name, p.user?.surname].filter(Boolean).join(' '),
    name: p.user?.name,
    last_name: p.user?.surname,
    currency: p.currency,
    payment_method: p.payment_method,
    ranking_category: p.ranking_category,
    process_limit: p.process_limit,
    process_limit_prefered: p.process_limit_preferred ?? null,
    status: p.status ? { id: p.status.id, name: p.status.name } : undefined,
    timezone: p.timezone ?? null,
  }));
  const total = resp.metadata?.total ?? data.length;
  return { data, total };
}


